import { Center, Loader } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'configs/routes';
import { userStore } from 'stores/global/RootStore';

/* HOC для страниц, для которых нужна авторизация */
export const withAuth = <P extends Record<string, unknown>>(Component: React.ComponentType<P>) =>
  observer((props: P) => {
    const navigate = useNavigate();
    const {
      user,
      loadingStage: { isError },
      fetchUser,
    } = userStore;

    React.useEffect(() => {
      if (!user) {
        fetchUser();
      }
    }, [user, fetchUser]);

    React.useEffect(() => {
      if (isError && !user) {
        navigate(ROUTES.login.create());
      }
    }, [navigate, isError, user]);

    if (!user) {
      return (
        <Center>
          <Loader />
        </Center>
      );
    }

    return <Component {...props} />;
  });
